export default __webpack_public_path__ + "static/media/1.2709e7d7.png";